import axios from 'axios'
import { getAuthToken } from '../utils/auth'

const baseUrl = `${
  process.env.REACT_APP_API_BASE_URL || 'https://pro.vibelinksapp.com/api'
}`

export const userNotificationOnOff = async formData => {
  const token = getAuthToken();
  // Enforce status field: 1 for On, 2 for Off
  if (!formData || typeof formData.status === 'undefined') {
    throw new Error('The status field is required. Use 1 for On, 2 for Off.');
  }
  // Optionally, you can coerce values here if needed
  const payload = { ...formData, status: formData.status === 2 ? 2 : 1 };
  const { getCurrentFCMToken } = await import('../utils/fcmToken');
  const fcmToken = await getCurrentFCMToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    'Accept-Language': 'en',
  };
  
  if (fcmToken) {
    headers['FCM-Token'] = fcmToken;
  }
  
  const response = await axios.post(
    `${baseUrl}/notifications-on-off`,
    payload,
    { headers }
  );
  return response.data;
}